var TagControlController = /** @class */ (function () {
    function TagControlController(component) {
        this.__component = component;
    }
    TagControlController.prototype.getOptions = function () {
        return this.__component.options.length < this.__component.limit ? this.__component.options : [];
    };
    TagControlController.prototype.getSuggestion = function () {
        return this.__component.options.length < this.__component.limit
            ? this.__component.suggestionText
            : this.__component.tooManySuggestionText;
    };
    TagControlController.prototype.getStatus = function () {
        if (this.__component.loadingError) {
            return 'error';
        }
        return this.__component.status;
    };
    TagControlController.prototype.getErrorStatusText = function () {
        return this.getStatus() === 'error' ? this.__component.errorText : null;
    };
    TagControlController.prototype.getLoadingStatusText = function () {
        return this.getStatus() === 'loading' ? this.__component.loadingText : null;
    };
    TagControlController.prototype.getStatusType = function () {
        return this.getStatus();
    };
    TagControlController.prototype.inputHandler = function (_a) {
        var detail = _a.detail;
        this.__component.value = detail.value;
        this.__component.__fireEvent('input', detail);
    };
    TagControlController.prototype.doRequest = function (value) {
        var _this = this;
        // load in the background, if the value is empty and we already have suggestions
        if (!this.__component.options.length || value !== '') {
            this.__component.status = 'loading';
        }
        return this.__component
            .doRequest(value)
            .then(function (options) {
            _this.__component.status = null;
            _this.__component.options = options;
        })
            .catch(function () {
            _this.__component.status = 'error';
        });
    };
    TagControlController.prototype.delayedInputHandler = function (_a) {
        var detail = _a.detail;
        this.__component.__fireEvent('delayedInput', detail);
        this.doRequest(this.__component.value);
    };
    TagControlController.prototype.keyBlurHandler = function () {
        this.__component.__fireEvent('blur');
    };
    TagControlController.prototype.focusHandler = function () {
        this.doRequest(this.__component.value);
    };
    return TagControlController;
}());
export default TagControlController;
//# sourceMappingURL=tag-control-controller.js.map